module.exports = __webpack_public_path__ + "img/faTuanChengLiBiao.6fd61558.png";